import { action } from "mobx";
import { Endpoint, Http } from "Application/Helpers/BaseEndpoint";
import { AppUrls } from "AppUrls";
import { IStudentSessionReportViewModel } from "../../Form/Interfaces/IStudentSessionReportViewModel";
import { StudentSessionContext } from "Shared/Models/StudentSessionReport";
import { SessionDocumentModel } from "Shared/Models/StudentSessionReport/SessionDocumentModel";

class Request {
    public id: string | null = null;
    public studentId: string | null = null;
    public documentCategoryId: string | null = null;
}

class Response {
    public id: string | null = null;
    public studentSessionId: string | null = null;
    public documentCategoryId: string = "";
    public documentCategoryName: string = "";
    public fileName: string = "";
    public fileSize: number = 0;
    public fileUrl: string = "";
    public createdDate: Date | null = null;
    public createdByUserId: string = "";
}

export class SaveSessionDocumentsEndpoint extends Endpoint<Request, Response> {
    private readonly viewModel: IStudentSessionReportViewModel;

    constructor(viewModel: IStudentSessionReportViewModel) {
        super();
        this.verb(Http.Post);
        this.path(AppUrls.Server.Student.StudentSessions.PostSaveStudentSessionDocument);
        this.viewModel = viewModel;
        this.AllowFileUploads();
    }

    public async HandleRequestAsync(model: StudentSessionContext): Promise<any> {
        let request: Request = new Request();
        request.id = model.id;
        request.studentId = model.studentId;
        request.documentCategoryId = model.documentCategoryId || null;
        const formData = new FormData();
        formData.append("data", JSON.stringify(request));
        for (const file of this.viewModel.filesViewModel.model?.files!) {
            formData.append("documentFile", file.file!);
        }
        return Promise.resolve(formData);
    }

    @action
    public async HandleResponseAsync(response: any): Promise<any> {
        const model = new SessionDocumentModel();
        model.fromResponse(response);
        this.viewModel.model.sessionDocument.push(model);
    }
}
